// src/components/SpotSiteBar.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { branches } from '../constant/spotsiteData';

const SpotSiteBar = () => {
  return (
    <Bar>
      <Inner>
        <Label>지점 소개</Label>
        <List role="list">
          {branches.map((b) => (
            <Item key={b.slug} role="listitem">
              <StyledLink to={`/spotsite?center=${b.slug}`}>
                {b.name}
              </StyledLink>
            </Item>
          ))}
        </List>
      </Inner>
    </Bar>
  );
};

export default SpotSiteBar;

const Bar = styled.div`
  width: 100%;
  border-top: 1px solid #e9e9e9;
  border-bottom: 1px solid #eee;
  background: #fafafa;
  box-sizing: border-box;
  @media (max-width: 1023px) {
    padding: 0 5%;
  }
`;

const Inner = styled.div`
  max-width: 1020px;
  margin: 0 auto;
  padding: 10px 16px 10px 0;
  display: flex;
  align-items: center;
  gap: 16px;
  box-sizing: border-box;
  @media (max-width: 430px) {
    flex-direction: column;
    justify-content: center;
  }
`;

const Label = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #555;
  white-space: nowrap;
`;

const List = styled.ul`
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
  @media (max-width: 430px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const Item = styled.li``;

const StyledLink = styled(Link)`
  font-size: 13px;
  color: #666;
  text-decoration: none;
  line-height: 1;
  padding: 6px 8px;
  border-radius: 6px;
  transition: background 0.15s, color 0.15s;
  &:hover {
    color: #222;
  }
`;
